
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plus/cft",
      function () {
        return require("private-next-pages/plus/cft/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plus/cft"])
      });
    }
  